
import React, { Component } from "react";
import { Modal } from "antd";
import { ExclamationCircleOutlined, PlusCircleOutlined, EnvironmentFilled } from '@ant-design/icons';
import Script from "react-load-script";
import _, { forEach, isEmpty, map } from "lodash";
import close from '../../../../../../Assets/images/close.png';

let Map;
let markers = [], center
let alphabateOrder = "";
let alphabateOrderPrefix = ""
// newList for new markers and markerList for existing markers
class DefineCoordinates extends Component {
  state = {
    markerList: this.props.markerList,
    newList: [],
    zoom: 8,
    coordinateValue: "",
    error: "",
    currentPosition: this.props.currentPosition,
    address: this.props.address
  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    if (nextProps?.markerList) {
      // this.setState({ markerList: nextProps?.markerList })
    }

    if (nextProps?.zoom && nextProps?.zoom !== this.state.zoom) {
      this.setState({ zoom: nextProps?.zoom })
    }
  }

  initAutocomplete = () => {
    var { currentPosition, address } = this.state;
    if (currentPosition.length > 0) {
      this.setInitialValues();
      // Create the search box and link it to the UI element.----------------------------------
      const input = document.getElementById("pacord-input");
      const searchBox = new window.google.maps.places.SearchBox(input);
      Map.controls[window.google.maps.ControlPosition.TOP_LEFT].push(input);

      searchBox.addListener("places_changed", () => this.onSearchLocation(searchBox));
      //---------------------------------------------------------------------------------------

      // event on bound change
      Map.addListener("bounds_changed", () => searchBox.setBounds(Map.getBounds()));

      // on Map click
      Map.addListener("click", (mapsMouseEvent) => this.onMapClick(mapsMouseEvent.latLng.toJSON()))

      // on zoom chaned
      Map.addListener("zoom_changed", () => this.setState({ zoom: Map.getZoom() }))
    } else {
      this.geoCoder(address).then(place => {
        var latitude = place.geometry.location.lat();
        var longitude = place.geometry.location.lng();
        currentPosition = [{lat:latitude , lng:longitude}];
        this.setState({currentPosition});
        this.setInitialValues();
        // Create the search box and link it to the UI element.----------------------------------
        const input = document.getElementById("pacord-input");
        const searchBox = new window.google.maps.places.SearchBox(input);
        Map.controls[window.google.maps.ControlPosition.TOP_LEFT].push(input);

        searchBox.addListener("places_changed", () => this.onSearchLocation(searchBox));
        //---------------------------------------------------------------------------------------

        // event on bound change
        Map.addListener("bounds_changed", () => searchBox.setBounds(Map.getBounds()));

        // on Map click
        Map.addListener("click", (mapsMouseEvent) => this.onMapClick(mapsMouseEvent.latLng.toJSON()))

        // on zoom chaned
        Map.addListener("zoom_changed", () => this.setState({ zoom: Map.getZoom() }))
      })
    }
  }

  // set initial pins and Map and center
  setInitialValues = () => {
    alphabateOrder = "";
    const { quoteDetail, isViewOnly } = this.props;
    var { markerList, zoom, currentPosition, address, newList } = this.state;
    //console.log(currentPosition);

    if (currentPosition.length > 0) {
      center = new window.google.maps.LatLng(currentPosition?.[0]?.lat, currentPosition?.[0]?.lng);
      zoom = 15;
    } else {
      center = new window.google.maps.LatLng(currentPosition?.[0]?.lat, currentPosition?.[0]?.lng);
      zoom = 15;
    }

    Map = new window.google.maps.Map(document.getElementById("location-Map"), {
      center,
      zoom: zoom || 8,
      mapTypeId: "roadmap",
    });

    markerList = markerList.concat(newList);
    newList = [];
    this.setState({ markerList });
    this.setState({ newList });

    markers = markerList?.map((obj, index) => {
      let new_marker = new window.google.maps.Marker({
        Map: Map,
        title: '',
        labels: isViewOnly ? '' : `${index + 1}`,
        label: isViewOnly ? '' : this.labelForMap(),
        position: new window.google.maps.LatLng(obj?.lat, obj?.lng),
        post: obj,
        draggable: !isViewOnly
      })
      // remove marker
      new_marker.addListener("click", () => {
        if (!isViewOnly) {
          Modal.confirm({
            title: 'Remove Marker',
            icon: <ExclamationCircleOutlined />,
            content: 'Are you sure?',
            okText: 'Yes',
            cancelText: 'No',
            onOk: () => {
              const { markerList } = this.state;
              markerList.splice(parseInt(new_marker.labels) - 1, 1)
              markers[parseInt(new_marker.labels) - 1].setMap(null)
              this.setState({ markerList });
              this.initAutocomplete();
            }
          });
        }
      });

      // drag marker
      window.google.maps.event.addListener(new_marker, 'dragend', (evt) => {
        const { markerList } = this.state;
        markerList[parseInt(new_marker.labels) - 1] = evt.latLng.toJSON()
        this.setState({ markerList })
      });
      // new_marker.setMap(Map);
      return new_marker
    });

    if (markerList.length > 1) {
      let bounds = new window.google.maps.LatLngBounds();
      for (let i = 0; i < markerList.length; i++) {
        bounds.extend(new window.google.maps.LatLng(parseFloat(markerList[i].lat), parseFloat(markerList[i].lng)));
      }
      Map.fitBounds(bounds);
    } else if (markerList.length === 1) {
      let bounds = new window.google.maps.LatLngBounds();

      bounds.extend(new window.google.maps.LatLng(parseFloat(markerList[0].lat), parseFloat(markerList[0].lng)));

      bounds.extend(new window.google.maps.LatLng(parseFloat(currentPosition[0].lat), parseFloat(currentPosition[0].lng)));

      Map.fitBounds(bounds);
    }
  }

  // on search location
  onSearchLocation = (searchBox) => {
    const places = searchBox.getPlaces();

    if (places.length === 0) {
      return;
    }
    // For each place, get the icon, name and location.
    const bounds = new window.google.maps.LatLngBounds();
    places.forEach((place) => {
      if (!place.geometry) { console.log("Returned place contains no geometry"); return; }
      // Create a marker for each place.
      this.onMapClick(place.geometry.location?.toJSON())

      if (place.geometry.viewport) {
        // Only geocodes have viewport.
        bounds.union(place.geometry.viewport);
      } else {
        bounds.extend(place.geometry.location);
      }
    });

    Map.fitBounds(bounds);
  }

  // on Map click
  onMapClick = (obj) => {
    const { isViewOnly } = this.props
    if (!isViewOnly) {
      const { newList, markerList } = this.state;
      if(!this.checkIfCoordinateExists(obj)){
        let new_marker = new window.google.maps.Marker({
          Map: Map,
          title: '',
          labels: `${markers.length + 1}`,
          //label:`${ alphabateOrder === "" ? ("A" , alphabateOrder='A')    : (String.fromCharCode(alphabateOrder.charCodeAt() + 1) , alphabateOrder =String.fromCharCode(alphabateOrder.charCodeAt() + 1))  }`,
          label: this.labelForMap(),
          position: new window.google.maps.LatLng(obj?.lat, obj?.lng),
          post: obj,
          draggable: !isViewOnly
        })
        // remove marker
        new_marker.addListener("click", () => {
          Modal.confirm({
            title: 'Remove Marker',
            icon: <ExclamationCircleOutlined />,
            content: 'Are you sure?',
            okText: 'Yes',
            cancelText: 'No',
            footer: <div><button className="btn btn-brand btn-bdr">Cancel</button><button className="btn btn-warning">Apply</button></div>,
            onOk: () => {
              const { newList } = this.state;
              let findNewIndex = newList.findIndex(x => x.lat === new_marker.position.lat() && x.lng === new_marker.position.lng());

              newList.splice(findNewIndex, 1);
              markers[parseInt(findNewIndex)].setMap(null)
              this.setState({ newList });
              this.initAutocomplete();
            }
          });
        });
        // drag marker
        window.google.maps.event.addListener(new_marker, 'dragend', (evt) => {
          const { newList } = this.state;
          let findNewIndex = newList.findIndex(x => x === new_marker.post);
          newList[parseInt(findNewIndex)] = evt.latLng.toJSON()
          this.setState({ newList })
        });
        // new_marker.setMap(map);

        markers.push(new_marker) // contains google map object
        newList.push(obj) // contains only lat lng
        this.setState({ newList })
      }
    }
  }

  labelForMap() {
    if (alphabateOrder === "") {
      alphabateOrder = "A";
    } else {
      alphabateOrder = this.getNextStringId(alphabateOrder);
    }
    return alphabateOrder;
  }

  // on remove all marker
  onRemoveAll = () => {
    for (let i = 0; i < markers.length; i++) {
      markers[i].setMap(null);
    }
    markers = [];
    this.setState({ newList: [], markerList: [] })
  }

  render() {
    const { visible, onCancel, onSave, isViewOnly } = this.props
    const { markerList, newList, zoom } = this.state;
    return (
      <Modal
        title={isViewOnly ? 'View Coordinates' : "Add Coordinates"}
        visible={visible}
        className="lg-modal add-cord-modal"
        onCancel={() => onCancel()}
        footer={[
          <button key="cancel" className="btn btn-success btn-bdr" onClick={() => onCancel()}>{isViewOnly ? 'Close' : 'Cancel'}</button>,
          // <button key="remove" className="btn btn-danger btn-bdr" onClick={() => this.onRemoveAll()}>Add Coordinates</button>,
          <button hidden={isViewOnly} key="save" className="btn btn-warning" onClick={() => {
            onSave([...markerList, ...newList], zoom)
            onCancel()
          }}>Add Coordinates</button>
        ]}
      >
        <div>
          {!isViewOnly && <p>Add service coordinates by entering them below or selecting them on the Map.</p>}

          <div id="gmap">
            <Script
              url={`https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_PLACE_API_KEY}&libraries=places`}
              onLoad={() => window.requestAnimationFrame(this.initAutocomplete)}
            />
            <div className="add-cord-row">
              <div className="add-cord-col-left">
                {!isViewOnly && <div className="add-cord-search">
                  <input
                    id=""
                    className="form-control"
                    type="text"
                    placeholder="Add Coordinates"
                    value={this.state.coordinateValue}
                    onChange={e => this.onChangeAddCoordinates(e.target.value)}
                  />
                  <button type="button" className="btn btn-warning" onClick={() => this.saveCoordinates()} ><PlusCircleOutlined /></button>
                </div>}
                {this.state.error !== "" ? <label className="new_err_msg"><i className="las la-info-circle" /> {this.state.error} </label> : ""}
                {!((markerList.length + newList.length) > 0) ? <div className="cordnate-list no-cord-add">
                  <div className="text-center">
                    <div className="mb-10">
                      <EnvironmentFilled />
                    </div>
                    <p className="mb-10"><strong>No Coordinates Added Yet</strong></p>
                    <p className="m-0">Add coordinates to the map to view them here.</p>
                  </div>
                </div>
                  :
                  <div className="cordnate-list" >
                    {this.renderCoordinateList(markerList)}
                    {this.renderNewCoordinateList(newList)}
                  </div>
                }
              </div>
              <div className="add-cord-col-right">
                <div id="location-Map" name={'location-Map'} style={{ width: '500px', height: '500px' }}></div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    );
  }

  removeFromList = (index) => {
    const { markerList } = this.state;
    let lngAndlt = markerList[index];
    let marker = markers.filter((x) => x.post === lngAndlt);
    markers[parseInt(marker[0].labels) - 1].setMap(null)
    markerList.splice(index, 1);
    this.setState({ markerList });
    this.initAutocomplete();
  }

  checkIfCoordinateExists(obj) {
    const { newList, markerList } = this.state;
    let temArr = [...newList, ...markerList];
    let marker = temArr.filter((x) => (String(x.lat).trim() === String(obj.lat).trim() && String(x.lng).trim() === String(obj.lng).trim()));
    if (marker.length > 0) {
      return true;
    } else {
      return false;
    }
  }

  removeFromNewList = (index) => {

    const { newList } = this.state;
    let lngAndlt = newList[index];
    let marker = markers.filter((x) => x.post === lngAndlt);

    markers[parseInt(marker[0].labels) - 1].setMap(null)
    newList.splice(index, 1);
    this.setState({ newList });
    this.initAutocomplete();
  }

  onChangeAddCoordinates(value) {
    var regExp = /[a-zA-Z]/g;
    if (!regExp.test(value)) {
      this.setState({ coordinateValue: value })
    }

  }

  saveCoordinates() {
    const { coordinateValue, newList, markerList, error } = this.state;
    const { isViewOnly } = this.props

    this.setState({ error: "" });
    // const regexExp = new RegExp('^-?([1-8]?[1-9]|[1-9]0)\\.{1}\\d{1,6}');
    // var ck_lat = /^(-?(90\.0{4,6})|([0-8]\d{0,1})\.\d{4,6})$/;
    //   var ck_lon =/^(-?((180)\.0{4,6})|((1[0-7][0-9])|([0-9]\d{0,1}))\.\d{4,6})$/;
    var tempArray = coordinateValue.split(",");
    if ((tempArray[0] >= -90 && tempArray[0] <= 90) && (tempArray[1] >= -180 && tempArray[1] <= 180)) {
      let obj = { lat: tempArray[0], lng: tempArray[1] }
      if (!this.checkIfCoordinateExists(obj)) {
        let new_marker = new window.google.maps.Marker({
          Map: Map,
          title: '',
          labels: `${markers.length + 1}`,
          label: this.labelForMap(),
          position: new window.google.maps.LatLng(obj?.lat, obj?.lng),
          post: obj,
          draggable: !isViewOnly
        });
        markers.push(new_marker);
        newList.push(obj);
        this.setState({ newList, coordinateValue: "" })
      } else {
        this.setState({ error: "Those coordinates have already been added." });
      }
    } else {
      if (coordinateValue === "") {
        this.setState({ error: "Enter coordinates or select on the map." });
      } else {
        this.setState({ error: "Invalid coordinates." });
      }
    }


    if (markerList.length === 0 && newList.length > 0) {
      var bounds = new window.google.maps.LatLngBounds();
      for (let i = 0; i < newList.length; i++) {
        bounds.extend(new window.google.maps.LatLng(parseFloat(newList[i].lat), parseFloat(newList[i].lng)));
      }
      Map.fitBounds(bounds,{padding: 100});
      Map.setZoom(16);
    }

  }

  //Get the lat and log from address
  geoCoder(address) {
    var geocoder = new window.google.maps.Geocoder();
    return new Promise((resolve, reject) => {
      geocoder.geocode({
        'address': address
      },
      function (results, status) {
        if (status === window.google.maps.GeocoderStatus.OK) {
          resolve(results[0]);
        }
      });
    });
    //return currentPosition;
  }

  renderCoordinateList(markerList) {
    const { isViewOnly } = this.props
    return map(markerList, (item, i) => {
      return (
        <div className="cordnate-blck" key={`item${i}`}>
          <span>{item.lat} ,{item.lng}</span>
          {!isViewOnly && <span onClick={(e) => { e.preventDefault(); this.removeFromList(i) }}><img src={close} alt="" /></span>}
        </div>
      )
    })
  }


  getNextStringId(str) {
    let index = str.length - 1;
    let baseCode = str.charCodeAt(index);
    do {
      baseCode = str.charCodeAt(index);
      let strArr = str.split("");
      if (strArr[index] === "Z") {
        strArr[index] = "A";
        if (index === 0) {
          strArr.unshift("A");
        }
      }
      else {
        strArr[index] = String.fromCharCode(baseCode + 1);
      }
      str = strArr.join("");
      index--;
    } while (baseCode === 90)
    return str;
  }

  renderNewCoordinateList(newList) {
    return map(newList, (item, i) => {
      return (
        <div className="cordnate-blck" key={`item${i}`}>
          <span>{item?.lat} ,{item?.lng}</span>
          <span onClick={(e) => { e.preventDefault(); this.removeFromNewList(i) }}><img src={close} alt="" /></span>
        </div>
      )
    })
  }

}

export default DefineCoordinates;
